import { render, staticRenderFns } from "./DesktopHeader.vue?vue&type=template&id=d869ba40&scoped=true&"
import script from "./DesktopHeader.vue?vue&type=script&lang=ts&"
export * from "./DesktopHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopHeader.vue?vue&type=style&index=0&id=d869ba40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d869ba40",
  null
  
)

export default component.exports